<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import BannerApi from "@/services/banner-api";
import Vue from 'vue'
// import Promotion from "@/components/promotion"; 

//import DynamicMarquee from 'vue-dynamic-marquee';

// import ItemCard from "@/components/itemCard";
// import CategoryCard from "@/components/CategoryCard";
import highlights from "@/components/highlights";
import highlightsSmall from "@/components/highlights-small";



import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
// import carousel from 'vue-owl-carousel'
//import simplebar from "simplebar-vue";

import ReportingApi from "@/services/reporting-api";
import UsersApi from "@/services/users-api";

export default {
  page: {
    title: "Page d'Accueil",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    Layout/*, simplebar, carousel, ItemCard, CategoryCard*/, highlights, highlightsSmall/*, Promotion*/
  },
  
  computed: {

    vueAppCustomerInfo() {
      const vueAppCustomerInfo = {
        address: process.env.VUE_APP_CUSTOMER_ADDRESS,
        email: process.env.VUE_APP_CUSTOMER_EMAIL,
        phone: process.env.VUE_APP_CUSTOMER_PHONE,
      };

      return vueAppCustomerInfo;
    },

    windowWidth() {
      return window.innerWidth;
    },

    role() {
      return this.$cookies.get('userr');
    }

  },

  data() {
    return {

      bannerList: [],
      isBannerTableBusy: false,

      nowAvailableItems: [],
      newSuppliers: [],
      newItems: [],

      topItems:[],
      isGetTopItemsStarting: false,

      newAccountCompanyName: null,
      newAccountCompanyPhone: null,

      homeLogos:["logo-bosch", "logo-cerva", "logo-ridgid", "logo-esab", "logo-facom", "logo-defender", "logo-tractel", "logo-3M", "logo-climax"],

      settings: {
          "dots": false,
          "dotsClass": "slick-dots custom-dot-class",
          "edgeFriction": 0.35,
          "infinite": true,
          "speed": 1000,
          "autoplay": true,
          "slidesToShow": 1,
          "slidesToScroll": 1,

          "fade": true,
          "arrows": false,

          //"vertical": true,
          //"verticalSwiping": true
        },


        settingsNewSuppliersBanner: {
          "dots": false,
          "dotsClass": "slick-dots custom-dot-class",
          "focusOnSelect": true,
          "infinite": true,
          "autoplay": true,
          "speed": 5000,
          "slidesToShow": 3,
          "slidesToScroll": 1,
          "touchThreshold": 5,
        },

        settingsNewItemBanner: {
          "dots": false,
          "dotsClass": "slick-dots custom-dot-class",
          "focusOnSelect": true,
          "infinite": true,
          "autoplay": true,
          "speed": 4000,
          "slidesToShow": 3,
          "slidesToScroll": 1,
          "touchThreshold": 1,
          "arrows": true,


          "responsive": [
              {
                "breakpoint": 1024,
                "settings": {
                  "slidesToShow": 2,
                  "slidesToScroll": 1,
                  "infinite": true,
                  "dots": false,
                  "arrows": false,
                }
              },
              {
                "breakpoint": 600,
                "settings": {
                  "slidesToShow": 1,
                  "slidesToScroll": 1,
                  "infinite": true,
                  "dots": false,
                  "arrows": false,
                }
              },
              {
                "breakpoint": 480,
                "settings": {
                  "slidesToShow": 1,
                  "slidesToScroll": 1,
                  "infinite": true,
                  "dots": false,
                  "arrows": false,
                }
              }
            ]


        }
    };
  },

  mounted() {

    this.findBanner(this.windowWidth);

    this.getTopTenItems();
    

    this.findNowAvailableItems();
    this.getNewItems();
    this.getNewSuppliers();

   
    
  },

  methods: {
    findBanner(windowWidth) {
      this.isBannerTableBusy = true;
      BannerApi.getBanners(windowWidth).then((result) => {
        this.bannerList = result;
      }).finally(() => {
        this.isBannerTableBusy = false;
      })
    },

    

    getNewSuppliers(){
      /*SuppliersApi.getAllNewSuppliers().then(
        response => {
          this.newSuppliers = response;
        }
      )*/
    },

    getNewItems(){
      /*ItemsApi.findNewItems().then(
        response => {
          this.settingsNewItemBanner.slidesToShow = response.length < 3 ? response.length : 3;
          this.newItems = response;
        }
      )*/
    },

    findNowAvailableItems(){
      /*ItemsApi.findNowAvailableItems().then(
        response => {
          
          this.nowAvailableItems = response;
        }
      )*/
    },


    getTopTenItems(){
            this.isGetTopItemsStarting=true
            ReportingApi.getTopTenItemsForHome().then(
                (result) => {
                    this.topItems=result.list;
                }
            ).finally(()=>{
                this.isGetTopItemsStarting=false
            })
      },

      addAccountRequest() {
        UsersApi.addAccountRequest(this.newAccountCompanyName, this.newAccountCompanyPhone)
        .then(
              (result) => {
                  if (result) {
                    Vue.prototype.$snotify.success('Votre demandée est ajoutée avec succès')
                    this.newAccountCompanyName = null;
                    this.newAccountCompanyPhone = null;
                  }
              }
            ).finally(()=>{
            })
      },

      // bestSellersNextSlide() {

      //   //this.$refs['bestSellersCaroussel'].trigger('owl.next');

      //   this.$refs['bestSellersCaroussel'].trigger('prev.owl.carousel');

      // },

      goTopPage() {
        window.scrollTo({top: 0,left: 0,behavior: 'smooth'});
      }

    


  }
};
</script>


<style>

.trending-content a span.img-marq {
    display: inline-block;
    line-height: 1;
    margin-right: 15px;
    position: relative;
}


.slick-arrow:before {
    font-family: 'slick';
    font-size: 20px;
    line-height: 1;
    opacity: 0.75;
    color: #787a76;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

.slick-next:before {
    font-family: 'slick';
    font-size: 20px;
    line-height: 1;
    opacity: 0.75;
    color: #787a76;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

.newitems .simplebar-scrollbar::before {
  background-color: #5cb45b;
}

.truncate-title {
  white-space: nowrap; 
  width: 100% ;
  overflow: hidden;
  text-overflow: ellipsis; 
}


carousel-item .active .img-fluid {
  border-radius:500px !important;
}

@media all and (max-width: 1199px) {
    .mobile-padding {
        padding-left: 20px !important;
        padding-right: 20px !important;
    } 
  }

 .overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #00acc840; /* #00acc81f;   #00000042;*/
  z-index: 1;
  pointer-events: none;
} 


.carousel-caption {
  position: absolute;
  top: 45%;
  left: 0;
  right: 0;
  transform: translateY(-50%);
  z-index: 2;
}
.banner-image {
  position: relative;
  z-index: 0;
}



.catalog-background {
  padding-top: 75px;
    padding-bottom: 70px;
    background-image:   url('~@/assets/images/cab/background/back.jpg');
    background-position: center;
    background-repeat: no-repeat;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
}

.footer-default {
  background: none;
}

@media (min-width: 992px) {
  .footer-default {
    background: #f7f6f6 url('~@/assets/images/footer-bg.png') no-repeat right 35px;
  }
}


</style>

<template>
  <Layout>
     
   

        <!-- Main Banners -->
        <div class="row pt-xl-0 d-none" >
          <!-- <div class="col-xl-9 col-sm-12 col-md-8" > -->
          <div class="col-12" >
            <div class="p-0" >
                <b-carousel
                  style="box-shadow:0 2px 6px 0 rgb(0 0 0 / 8%);"
                    img-width="1920"
                    img-height="400" 
                    :interval="4000"
                    

                    :controls="false"
                    :indicators="false"
                    :pause-hover="true"
                    :pause-on-hover="true"
                    :no-touch="false"
                    :fade="true">

                    <b-carousel-slide class="bg-light"  
                              style="width:1920px; height:565px;" 
                              img-blank img-alt="Blank Image " 
                              img-width="1900"
                    img-height="400" 
                              v-if="isBannerTableBusy || !bannerList || !bannerList.length">
                      <!-- <p class="text-secondary">
                        caption="Restez à l'écoute!" 
                        Les publicitées seront disponibles prochainement
                      </p> -->

                    </b-carousel-slide> 

                    <b-carousel-slide v-for="banner in bannerList" :key="banner.id">
                      <template #img>
                        <div class="overlay"></div>
                        <img :src="'/api/banner/get/' + banner.generatedName" alt="Banner Image" class="banner-image" width="100%">
                      </template>
                      <div class="carousel-caption">
                        <h3 class="d-none d-xl-block text-white text-uppercase font-weight-bold" style="font-size:3.5rem;line-height: 1.5;">Répartiteur En Médicaments & Produits De Santé</h3>
                        <!-- <h3 class="d-md-none text-white text-uppercase font-weight-bold">Répartiteur En Médicaments & Produits De Santé</h3> -->
                        <p class="d-none d-xl-block text-uppercase font-weight-bold text-white font-size-16">Produits pharmaceutiques, Para-pharmaceutiques & Dispositifs médicaux</p>
                      </div>

                      <div>

                      

                      </div>

                    </b-carousel-slide>
                    
                 
                </b-carousel>



            </div>
          </div>


        </div>


        <div class="row pt-xl-0 pb-0" >
          <div class="col-12">
            <!--div class="overlays"/-->
            <video width="100%"  class="banner-video-mobile" loop playsinline autoplay muted  >
              <source src="@/assets/videos/cabdephar.mp4" type="video/mp4" >
            </video>
          </div>
				</div>
  
    
    <div class="">

    

        <!-- Promotions -->
        <!-- <highlights :propDisplayTitle="false" :propWhiteBackground="false" /> -->

        <!-- TOP ITEMS -->
        <!-- border: 1px solid #eaf8f8;  -->
        <div class="row mt-4 pt-xl-4 pb-4 mb-4 p-0 p-md-4 home-page-80-width catalog-background"  style="border-radius:10px; margin-bottom:50px !important;">
          <div class="col-12"> 

              <div class="row ml-4 mr-4 mt-2 mb-2">
                <div class="col-xl-3 col-0 text-left"/>
                <div class="col-xl-6 col-12 text-left">
                  <h2 class="text-primary font-weight-bold">
                    
                          Catalogue <span class="d-none d-lg-inline">des</span> Produits <span class="d-none d-lg-inline">de Cabdephar</span>

                    
                  
                  </h2>
                  <h3 class="text-success font-weight-bold">Plus de 20 000 articles <span class="d-none d-lg-inline">pharmaceutiques & Para-Pharamceutiques</span></h3>

                
                  <p class="text-justify font-size-14 text-secondary mt-4">Cabdephar est un des leaders dans le secteur de la logistique de la santé du laboratoire aux patients. 
                    Notre objectif est de répondre aux besoins en constante évolution du marché tunisien de la santé en offrant une gamme complète de 
                    produits de haute qualité à des prix compétitifs</p>


                  
                    <div class="row">

                        <div class="col-sm-6 d-flex align-items-center mb-3">
                          <img src="@/assets/images/prod-icon1.png" height="50" />
                          <div class="pl-3 pt-2">
                            <span class="text-secondary font-size-14 " style="font-weight:900; ">Médicaments</span>
                            <p class="text-secondary  " style="font-weight:500; ">Médicaments princeps & génériques</p>
                          </div>
                        </div>

                        <div class="col-sm-6 d-flex align-items-center mb-3">
                          <img src="@/assets/images/prod-icon2.png" height="50" />
                          <div class="pl-3 pt-2">
                            <span class="text-secondary font-size-14 " style="font-weight:900; ">Produits Para-Pharmaceutiques</span>
                            <p class="text-secondary  " style="font-weight:500; ">Beauté, bien-être et soins personnels</p>
                          </div>
                        </div>

                        <div class="col-sm-6 d-flex align-items-center mb-3">
                          <img src="@/assets/images/prod-icon3.png" height="50" />
                          <div class="pl-3 pt-2">
                            <span class="text-secondary font-size-14 " style="font-weight:900; ">Dispositifs Médicaux</span>
                            <p class="text-secondary  " style="font-weight:500; ">Instruments, appareils, équipements, ...</p>
                          </div>
                        </div>

                        

                        <div class="col-sm-6 d-flex align-items-center mb-3">
                          <img src="@/assets/images/prod-icon4.png" height="50" />
                          <div class="pl-3 pt-2">
                            <span class="text-secondary font-size-14 " style="font-weight:900; ">Compléments Alimentaires</span>
                            <p class="text-secondary  " style="font-weight:500; ">Vitamines, minéraux, oligo-éléments, ...</p>
                          </div>
                        </div>

                       

                    </div>

                    <div class="row mt-3">

                          <div class="col-6 pr-3">

                            
                            <!-- <router-link to="/catalogue" >
                            
                              <b-button variant="outline-success" class="w-100">
                                <i class="  far fa-user font-size-18 mr-2 "></i> 
                                  <span class=" font-size-18 text-uppercase font-weight-bold d-none d-md-inline">Espace Professionnels</span>
                                  <span class=" font-size-18 text-uppercase font-weight-bold d-md-none">PRO</span>

                                  
                              </b-button>
                            </router-link> -->
                          </div>

                          <div class="col-6 pl-3">
                            <router-link to="/catalogue" >
                              <b-button variant="success" class="w-100">
                                  <!-- <i class="  bx bx-search-alt mr-1 " style="font-size:22px;"></i>  -->
                                  <span class=" font-size-18 text-uppercase font-weight-bold d-none d-md-inline">DECOUVREZ NOS ARTICLES</span>
                                  <span class=" font-size-18 text-uppercase font-weight-bold d-md-none">ARTICLES</span>
                                  <i class="ml-2 font-size-20 fa fa-angle-right d-none d-md-inline"></i>
                              </b-button>
                              </router-link>
                            </div>

                    </div>

                   
                </div>

                <div class="col-xl-3 col-0">
                    <!--div class="row mt-4 pt-4">
                      <div class="col-12 text-center">
                        <a href="https://www.facebook.com/cropapage/?locale=fr_FR" target="_blank">
                          <img src="@/assets/images/cropt-event.jpg" height="200" />
                        </a>
                      </div>
                      <div class="col-12 text-center  mt-2">
                        <a href="https://www.facebook.com/cropapage/?locale=fr_FR" target="_blank">
                          <span style="color:#000;" class="font-weight-bold">CROPA {{ new Date().getFullYear() }}</span>
                        </a>
                      </div>
                    </div-->
                    
                </div>

              </div>


          </div>
          
        
        </div>


       <!-- Promotions -->
       <highlights :propDisplayTitle="true" />

        
        

         
        <div class="row bg-white">

            <div class="col-12">
              <highlightsSmall :propDisplayTitle="true" class="" />
            </div>
        </div>

         
       
                  
        <!-- <div class="row mt-4 pt-4 home-page-80-width catalog-background" style="border-radius:10px; ">

          <div class="col-3"></div>
            <div class="col-6">
              <Promotion />
            </div>

        </div> -->

        
       
        
       
        <div class="bg-light footer-default "  >
          <div class="row pt-4 home-page-80-width" style="padding-bottom:40px; ">
            <div class="col-12"> 

                <div class="row pb-1">

                    <div class="col-xl-3 col-md-6 col-sm-12 col-xs-12 p-2 text-left" >

                        <img src="@/assets/images/cab/logo.png" alt height="30" />
              
                        <p class="mt-3 p-3 text-secondary text-justify font-weight-bold" style="color:#92B9B1">Grossiste et Répartiteur de médicaments, de dispositifs médicaux, de produits pharmaceutiques et para-pharmaceutiques depuis 1987.</p>
                    </div>


                    <div class="col-xl-3 col-md-6 col-sm-12 col-xs-12 p-2 text-left" >
                      <h5 class="text-primary font-weight-bold " >CONTACTEZ-NOUS</h5>


                        <ul style="list-style: none;margin: 0;padding: 0; " class="mt-4">
                            <li class="text-dark font-weight-normal font-size-14 mt-2">
                              <i class=" fas fa-map-marker-alt mr-2" style="color:#92B9B1;"/>
                              <span class="text-dark font-weight-normal font-italic">{{vueAppCustomerInfo.address}}</span>
                            </li>

                            <li class="font-weight-normal font-size-14 mt-2">
                              <i class="fas fa-envelope mr-2" style="color:#92B9B1;"/>
                              <span class="text-dark font-weight-normal font-italic">{{vueAppCustomerInfo.email}}</span>
                            </li>          
                            
                            <li class=" font-weight-normal font-size-14 mt-2">
                              <i class=" fas fa-clock mr-2" style="color:#92B9B1;"/>
                              <span class="text-dark font-weight-normal font-italic">Du lundi au samedi de 08h à 17h</span>
                            </li>

                            <li class=" font-weight-normal font-size-14 mt-2">
                              <i class=" fas fa-phone-alt mr-2" style="color:#92B9B1;" />
                              <span class="text-dark font-weight-normal font-italic">{{vueAppCustomerInfo.phone}}</span>
                            </li>    
                        </ul>
                    </div>


                    

                    <div class="col-xl-3 col-md-6 col-sm-12 col-xs-12 p-2 text-left">
                      <h5 class="text-primary font-weight-bold " style="">NOS PRODUITS</h5>
                      <ul style="list-style: none;margin: 0;padding: 0;" class="mt-4">
                        
                        <li class="font-size-14 mt-2 ">
                              <i class=" fas fa-pills mr-2" style="color:#92B9B1;"/>
                              <a class="text-dark" href="/catalogue">Tout le catalogue</a>
                            </li>

                        <li class="font-size-14 mt-2">
                              <i class=" fas fa-pills mr-2" style="color:#92B9B1;"/>
                              <a class="text-dark" href="/catalogue">Produits Pharmaceutiques</a>
                            </li>

                            <li class="font-size-14 mt-2">
                              <i class=" fas fa-pills mr-2" style="color:#92B9B1;"/>
                              <a class="text-dark" href="/catalogue">Produits Para-Pharmaceutiques</a>
                            </li>

                            <li class="font-size-14 mt-2">
                              <i class=" fas fa-pills mr-2" style="color:#92B9B1;"/>
                              <a class="text-dark" href="/catalogue">Dispositifs Médicaux</a>
                            </li>

                        </ul>

                    </div>

                    <!-- <div class="col-xl-3 col-md-6 col-sm-12 col-xs-12 p-4 text-left">
                      <h5 class="text-white font-weight-bold" style="">FAMILLES DE PRODUITS</h5>
                      <ul style="list-style: none;margin: 0;padding: 0;" class="mt-4">
                        
                            <li class="font-size-12 mt-2">
                              <a class="text-white" href="/catalogue/divers">Divers</a>
                            </li>

                          <li class="font-size-12 mt-2">
                              <a class="text-white" href="/catalogue/soudage">Soudage</a>
                            </li>
                        
                            <li class="font-size-12 mt-2">
                              <a class="text-white" href="/catalogue/manutention">Manutention</a>
                            </li>

                            
                        </ul>

                    </div> -->

                    <div class="col-xl-2 col-md-6 col-sm-12 col-xs-12 p-2 text-left" >
                      
                        <h5 class="text-primary font-weight-bold" style="">ESPACE CLIENT</h5>
                      <ul style="list-style: none;margin: 0;padding: 0;" class="mt-4">
                          
                            <li class="font-size-14 mt-2">
                              <i class=" fas fa-user mr-2" style="color:#92B9B1;"/>
                              <a class="text-dark" href="/profil">Profil Utilisateur</a>
                            </li>
                            
                            <li class="font-size-14 mt-2">

                              <i class=" fas fa-file-alt mr-2" style="color:#92B9B1;"/>
                              <a class="text-dark" href="/commandes">Commandes</a>
                            </li>
                        </ul>
                    </div>

                    <!-- <div class="col-lg-2 col-md-6 col-sm-12 col-xs-12 p-4 text-left">
                      <h5 class="text-white font-weight-bold" style="">INFORMATIONS LÉGALES</h5>
                      <ul style="list-style: none;margin: 0;padding: 0;" class="mt-4">
                            <li class="font-size-12 mt-2">
                              <a class="text-white" href="">Conditions d'utilisation</a>
                            </li>

                            <li class="font-size-12 mt-2">
                              <a class="text-white" href="">Mentions légales</a>
                            </li>

                            <li class="font-size-12 mt-2">
                              <a class="text-white" href="">Protection des données</a>
                            </li>
                        </ul>
                    </div> -->

                    <div class="col-xl-1 col-md-12 col-sm-12 col-xs-12 p-2 text-right">
                      <a href="javascript:void(0);" @click="goTopPage()" class="text-primary font-weight-bold" style="font-size:36px;"><i class="far fa-arrow-alt-circle-up"/></a>
                    
                    </div>
                    

                  

                </div>

              

            </div>
            

          </div>
        </div>


        

    
         
       
    
    </div>
    
    

  



 


  </Layout>
</template>

